import { CheckCircleOutlined, ClockCircleOutlined } from "@ant-design/icons";

import { useAppSelector } from "@/hooks/redux";
import { SecondaryText } from "@/shared/ui/Typography";

import { StyledTeamHeader } from "../../Styled";

export const TeamHeader = () => {
    const { lastUpdated } = useAppSelector((state) => state.manager);

    if (!lastUpdated?.team && !lastUpdated?.activeSchedule) {
        return null;
    }

    return (
        <StyledTeamHeader>
            {lastUpdated?.team && (
                <SecondaryText>
                    <ClockCircleOutlined />
                    Команда: {lastUpdated.team}
                </SecondaryText>
            )}

            {lastUpdated?.activeSchedule && (
                <SecondaryText>
                    <CheckCircleOutlined />
                    Маршрут: {lastUpdated.activeSchedule}
                </SecondaryText>
            )}
        </StyledTeamHeader>
    );
};
